var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ItemZoomControl" }, [
    _c("div", { staticClass: "ItemZoomControl_Label" }, [
      _vm._v("\n    zoom\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ItemZoomControl_Item" }, [
      _c("input", {
        staticClass: "ItemZoomControl_Range",
        attrs: {
          type: "range",
          step: "0.25",
          min: "0.5",
          max: "1.5",
          value: "1"
        },
        on: { input: _vm.onInput }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }